import { EDataBaseType } from "@kuika/kuika-cl-model";

declare let window: any;

const LocalStorageService = (function () {
  let _service: any;
  function _getService(this: {
    getService: () => any;
    setToken: (tokenObj: any) => void;
    getAccessToken: () => string | null;
    getRefreshToken: () => string | null;
    clearToken: () => void;
  }) {
    if (!_service) {
      _service = this;
      return _service;
    }
    return _service;
  }
  function _getExpandedPanelItem(actionId: string): boolean {
    let expandedPanelItems: string[] = [];
    const expandedPanelItemsJson: string = window.localStorage.getItem("expandedPanelItems");
    if (expandedPanelItemsJson && expandedPanelItemsJson.length > 0) {
      expandedPanelItems = JSON.parse(expandedPanelItemsJson);
    }
    const findedItem = expandedPanelItems.find((o) => o === actionId);
    return findedItem !== undefined;
  }
  function _setExpandedPanelItem(actionId: string, value: boolean) {
    const expandedPanelItemsJson: string = window.localStorage.getItem("expandedPanelItems");
    let expandedPanelItems: string[] = [];
    if (expandedPanelItemsJson && expandedPanelItemsJson.length > 0) {
      expandedPanelItems = JSON.parse(expandedPanelItemsJson);
    }
    if (value === false) {
      expandedPanelItems = expandedPanelItems.filter((o) => o !== actionId);
    } else if (value === true) {
      const findedItem = expandedPanelItems.find((o) => o === actionId);
      if (findedItem === undefined) {
        expandedPanelItems.push(actionId);
      }
    }
    localStorage.setItem("expandedPanelItems", JSON.stringify(expandedPanelItems));
  }
  function _setToken(tokenObj: any) {
    localStorage.setItem("tokenString", tokenObj.tokenString);
    localStorage.setItem("refreshToken", tokenObj.refreshToken);
  }
  function _setForgotPasswordEmail(email: string) {
    localStorage.setItem("forgotPasswordEmail", email);
  }
  function _setCurrentDomain(domainName: string) {
    window.currentDomain = domainName;
  }
  function _getForgotPasswordEmail() {
    return localStorage.getItem("forgotPasswordEmail");
  }
  function _getAccessToken() {
    return localStorage.getItem("tokenString");
  }
  function _getRefreshToken() {
    return localStorage.getItem("refreshToken");
  }
  function _getCurrentDomain() {
    return window.currentDomain;
  }
  function _setAuthenticatedWithCustomProvider(customAuthProvider: string) {
    localStorage.setItem("customAuthProvider", customAuthProvider);
  }
  function _getAuthenticatedWithCustomProvider() {
    return localStorage.getItem("customAuthProvider");
  }
  function _clearToken() {
    localStorage.removeItem("tokenString");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("forgotPasswordEmail");
    localStorage.removeItem("customAuthProvider");
    sessionStorage.clear();
  }
  function _setDomainAuthInfo(value: string) {
    localStorage.setItem("isDomainAuthorizationEnabled", value);
  }
  function _getDomainAuthInfo() {
    return localStorage.getItem("isDomainAuthorizationEnabled");
  }
  function _setCurrentDomainManagedDbType(value?: number) {
    // MSSQL => 1
    // Oracle => 2
    window.currentDomainManagedDbType = value;
  }
  function _getCurrentDomainManagedDbType(): EDataBaseType {
    return window.currentDomainManagedDbType;
  }
  return {
    getExpandedPanelItem: _getExpandedPanelItem,
    setExpandedPanelItem: _setExpandedPanelItem,
    getService: _getService,
    setToken: _setToken,
    setCurrentDomain: _setCurrentDomain,
    getAccessToken: _getAccessToken,
    getRefreshToken: _getRefreshToken,
    clearToken: _clearToken,
    setForgotPasswordEmail: _setForgotPasswordEmail,
    getForgotPasswordEmail: _getForgotPasswordEmail,
    getCurrentDomain: _getCurrentDomain,
    setAuthenticatedWithCustomProvider: _setAuthenticatedWithCustomProvider,
    getAuthenticatedWithCustomProvider: _getAuthenticatedWithCustomProvider,
    setDomainAuthInfo: _setDomainAuthInfo,
    getDomainAuthInfo: _getDomainAuthInfo,
    setCurrentDomainManagedDbType: _setCurrentDomainManagedDbType,
    getCurrentDomainManagedDbType: _getCurrentDomainManagedDbType
  };
})();
export default LocalStorageService;
